export const defaultShopInformations = {
  name: '',
  logoUrl: '',
};
